module.exports = __webpack_public_path__ + "static/media/hewenna.fdf9192e.png";